import { useState, type CSSProperties } from 'react';

const AVATAR_COLORS = ['#4361ee', '#7c5cfc', '#0a7d49', '#b4232c', '#9a6700', '#0e7490', '#be185d', '#4d7c0f'];

export function avatarColor(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length]!;
}

export function avatarInitials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '').join('') || '?';
}

/**
 * Round user avatar: shows the profile photo synced from Teams/Graph
 * (served by /api/v2/users/:id/avatar), falling back to colored initials when
 * there's no photo (or it fails to load).
 */
export function UserAvatar({ id, name, size = 24, hasPhoto = true, className = '', style }: {
  id: string;
  name: string;
  size?: number;
  hasPhoto?: boolean;
  className?: string;
  style?: CSSProperties;
}) {
  const [broken, setBroken] = useState(false);
  const dim: CSSProperties = { width: size, height: size, ...style };
  if (id && hasPhoto && !broken) {
    return (
      <img
        src={`/api/v2/users/${id}/avatar`}
        alt={name}
        title={name}
        onError={() => setBroken(true)}
        className={`rounded-full object-cover bg-surface2 shrink-0 ${className}`}
        style={dim}
      />
    );
  }
  return (
    <span
      title={name}
      className={`rounded-full inline-flex items-center justify-center font-semibold text-white shrink-0 select-none ${className}`}
      style={{ ...dim, fontSize: Math.max(9, Math.round(size * 0.4)), background: avatarColor(id) }}
    >
      {avatarInitials(name)}
    </span>
  );
}
